import React from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, colors, fontWeights } from '@/styles'
import ReadMoreText from '@/components/read-more-text'
import ReadMoreTextBlurred from '@/components/read-more-text-blurred'

type Props = {
  description: string
  isListingLocked: boolean
}

const InnerWrapper = styled.div`
  display: grid;
  flex-direction: column;
  grid-template-columns: 1fr;
  grid-gap: 16px 0;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    grid-template-columns: repeat(1, 1fr);
  }
`
const InnerWrapperBlurred = styled.div`
  display: grid;
  flex-direction: column;
  grid-template-columns: 1fr;
  grid-gap: 16px 0;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    z-index: 1;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    grid-template-columns: repeat(1, 1fr);
  }
`

const SubTitle = styled.span`
  font-size: 20px;
  font-weight: ${fontWeights.bold};
  line-height: 28px;
  font-family: 'Inter';
`

const Section = styled.div`
  background: ${colors.background};
  border-radius: 8px;
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 24px;
  margin: 16px 0 32px;
`

const ListingDescription = ({ description, isListingLocked }: Props) => {
  const { t } = useTranslation()

  if (!(description && !(description === ''))) return null

  return (
    <>
      <SubTitle>{t('listing:description.title', 'Description')}</SubTitle>
      <Section>
        {isListingLocked ? (
          <InnerWrapperBlurred>
            <ReadMoreTextBlurred
              align="left"
              description={description}
              maxChar={500}
            />
          </InnerWrapperBlurred>
        ) : (
          <InnerWrapper>
            <ReadMoreText
              align="left"
              description={description}
              maxChar={1000}
            />
          </InnerWrapper>
        )}
      </Section>
    </>
  )
}

export default ListingDescription
